import { singleOrArrayToArray } from '@dirootie-extensions/javascript';
import { IUserContext,RoleType } from './iam.types';
import { IKeyedObject, SingleOrArray } from '@dirootie-extensions/typescript';

export const roleMapper: IKeyedObject<RoleType> = {
  Admin: 'STUDY_DIRECTOR',
  Lecturer: 'LECTURER',
  Student: 'STUDENT',
  "Access.Admin": 'STUDY_DIRECTOR',
  "Access.Lecturer": 'LECTURER',
  "Access.Student": 'STUDENT',
};

export const roleImpersonatedMapper: {[key in RoleType]:RoleType[]} = {
  "STUDY_DIRECTOR": ["STUDY_DIRECTOR", "LECTURER","STUDENT"],
  "LECTURER": ["LECTURER","STUDENT"],
  "STUDENT": ["STUDENT"]
}

export const isImpersonating = (userContext: IUserContext) => {
  return userContext.role !== userContext.roleImpersonated;
}

export const canImpersonate = (userRole:RoleType, roleImpersonated: RoleType) => {
  return roleImpersonatedMapper[userRole].includes(roleImpersonated);
}

export const hasPermission = (currentUserRole:RoleType, roles: SingleOrArray<RoleType>) => {
  const allowedRoles = singleOrArrayToArray(roles);
  const hasPermission = allowedRoles.includes(currentUserRole);
  return hasPermission;
}
